import React, { Component } from "react";
import { DataTable } from "primereact/components/datatable/DataTable";
import { Column } from "primereact/components/column/Column";
//import { ProgressSpinner } from "primereact/components/progressspinner/ProgressSpinner";
import { Button } from "primereact/components/button/Button";
import { Growl } from "primereact/components/growl/Growl";
import { Dialog } from "primereact/components/dialog/Dialog";

//Imports from common
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
//import { formatId } from "../../common/FormatId";

export class ContractorUsers extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      test: "",
      userList: [],
      userSelected: false,
      userEdited: false,
      userAdded: false,
      userDeleted: false,
      selectedUser: "",
      userAddressLine1: "",
      userAddressLine2: "",
      userCodeTag: "",
      userContactTelephone: "",
      userCountryCode: "",
      userEmail: "",
      userFirstName: "",
      userId: "",
      userLastUpdatedDateTime: "",
      userPostcode: "",
      userRoleType: "",
      userSurname: "",
      userTown: "",
      editedUserFirstName: "",
      editedUserSurname: "",
      editedUserEmail: "",
      editedUserContactTelephone: "",
      editedUserAddressLine1: "",
      editedUserAddressLine2: "",
      editedUserPostcode: "",
      editedUserTown: ""
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers = async () => {
    this.setState({ loaded: false });

    let userRequest = new CloudService.UserRequest();
    userRequest.codeTag = localStorage.getItem("contractorId");

    await api("userApiV1UserListInBusinessGlobal", userRequest).then(res => {
      if (res.data.users !== undefined) {
        res.data.users.forEach(e => {
          e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
        });
      }

      let userResponse = CloudService.UserResponse.constructFromObject(
        res.data
      );
      console.log(userResponse);

      if (userResponse.errorCode === 0) {
        this.setState({
          userList: userResponse.users
        });
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving data, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true });
  };

  editUser = async () => {
    this.setState({ loaded: false });

    let userRequest = new CloudService.UserRequest();
    userRequest.codeTag = localStorage.getItem("contractorId");
    userRequest.id = this.state.userId;
    userRequest.lastUpdatedDateTime = this.state.userLastUpdatedDateTime;
    userRequest.firstName = this.state.editedUserFirstName;
    userRequest.surname = this.state.editedUserSurname;
    userRequest.email = this.state.editedUserEmail;
    userRequest.contactTelephone = this.state.editedUserContactTelephone;
    userRequest.addressLine1 = this.state.editedUserAddressLine1;
    userRequest.addressLine2 = this.state.editedUserAddressLine2;
    userRequest.postcode = this.state.editedUserPostcode;
    userRequest.town = this.state.editedUserTown;

    await api("userApiV1UserUpdateAccountGlobal", userRequest).then(res => {
      let userResponse = CloudService.UserResponse.constructFromObject(
        res.data
      );
      console.log(userResponse);

      if (userResponse.errorCode === 0) {
        this.setState({
          userEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "User successfully updated",
          life: 3000
        });
        this.getUsers();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the user, please try again",
          life: 3000
        });
      }
    });
  };

  addUser = async () => {
    this.setState({ loaded: false });

    let userRequest = new CloudService.UserRequest();
    userRequest.codeTag = localStorage.getItem("contractorId");
    userRequest.firstName = this.state.editedUserFirstName;
    userRequest.surname = this.state.editedUserSurname;
    userRequest.email = this.state.editedUserEmail;
    userRequest.contactTelephone = this.state.editedUserContactTelephone;
    userRequest.addressLine1 = this.state.editedUserAddressLine1;
    userRequest.addressLine2 = this.state.editedUserAddressLine2;
    userRequest.postcode = this.state.editedUserPostcode;
    userRequest.town = this.state.editedUserTown;
    userRequest.roleType = 120;

    await api("userApiV1UserCreateGlobal", userRequest).then(res => {
      let userResponse = CloudService.UserResponse.constructFromObject(
        res.data
      );
      console.log(userResponse);

      if (userResponse.errorCode === 0) {
        this.setState({
          userEdited: false,
          userAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "User successfully created",
          life: 3000
        });
        this.getUsers();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the user, please try again",
          life: 3000
        });
      }
    });
  };

  deleteUser = async () => {
    this.setState({ loaded: false });

    let userRequest = new CloudService.UserRequest();
    userRequest.codeTag = localStorage.getItem("contractorId");
    userRequest.id = this.state.userId;
    userRequest.lastUpdatedDateTime = this.state.userLastUpdatedDateTime;

    await api("userApiV1UserDeleteGlobal", userRequest).then(res => {
      let userResponse = CloudService.UserResponse.constructFromObject(
        res.data
      );
      console.log(userResponse);

      if (userResponse.errorCode === 0) {
        this.setState({
          userSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "User successfully deleted",
          life: 3000
        });
        this.getUsers();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the user, please try again",
          life: 3000
        });
      }
    });
  };

  render() {
    return (
      <div className="ui-g dashboard">
        <Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <Dialog
          header="Delete User"
          footer={
            <div>
              <Button
                label="Yes"
                onClick={() => {
                  this.setState({ userDeleted: false });
                  this.deleteUser();
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#01a4ef"
                }}
              />
              <Button
                label="No"
                onClick={() => {
                  this.setState({ userDeleted: false });
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#808080"
                }}
              />
            </div>
          }
          visible={this.state.userDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ userDeleted: false })}
        >
          Are you sure you want to delete?
        </Dialog>
        {this.state.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Users Card*/}
            {this.state.userSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>First Name: </b>
                    <label>{this.state.userFirstName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Surname: </b>
                    <label>{this.state.userSurname || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Email: </b>
                    <label>{this.state.userEmail || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Telephone: </b>
                    <label>
                      {this.state.userContactTelephone || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Address Line 1: </b>
                    <label>{this.state.userAddressLine1 || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Address Line 2: </b>
                    <label>{this.state.userAddressLine2 || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <b>Postcode: </b>
                    <label>{this.state.userPostcode || "Not Set"}</label>
                  </div>
                  <div className="ui-g-6">
                    <b>Town: </b>
                    <label>{this.state.userTown || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Edit"
                    onClick={() => {
                      this.setState({
                        userSelected: false,
                        userEdited: true,
                        userAdded: false,
                        editedUserFirstName: this.state.userFirstName,
                        editedUserSurname: this.state.userSurname,
                        editedUserEmail: this.state.userEmail,
                        editedUserContactTelephone: this.state
                          .userContactTelephone,
                        editedUserAddressLine1: this.state.userAddressLine1,
                        editedUserAddressLine2: this.state.userAddressLine2,
                        editedUserPostcode: this.state.userPostcode,
                        editedUserTown: this.state.userTown
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Delete"
                    onClick={() => {
                      this.setState({ userDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Users Card*/}
            {this.state.userEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedUserFirstName === "" ||
                          this.state.editedUserFirstName === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedUserFirstName || ""}
                        onChange={e =>
                          this.setState({
                            editedUserFirstName: e.target.value
                          })
                        }
                      />
                      <label>First Name *</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedUserSurname === "" ||
                          this.state.editedUserSurname === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedUserSurname || ""}
                        onChange={e =>
                          this.setState({
                            editedUserSurname: e.target.value
                          })
                        }
                      />
                      <label>Surname *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedUserEmail === "" ||
                          this.state.editedUserContactTelephone === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedUserEmail || ""}
                        onChange={e =>
                          this.setState({
                            editedUserEmail: e.target.value
                          })
                        }
                      />
                      <label>Email *</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedUserContactTelephone === "" ||
                          this.state.editedUserContactTelephone === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedUserContactTelephone || ""}
                        onChange={e =>
                          this.setState({
                            editedUserContactTelephone: e.target.value
                          })
                        }
                      />
                      <label>Telephone *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedUserAddressLine1 === "" ||
                          this.state.editedUserAddressLine1 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedUserAddressLine1 || ""}
                        onChange={e =>
                          this.setState({
                            editedUserAddressLine1: e.target.value
                          })
                        }
                      />
                      <label>Address Line 1</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedUserAddressLine2 === "" ||
                          this.state.editedUserAddressLine2 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedUserAddressLine2 || ""}
                        onChange={e =>
                          this.setState({
                            editedUserAddressLine2: e.target.value
                          })
                        }
                      />
                      <label>Address Line 2</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedUserPostcode === "" ||
                          this.state.editedUserPostcode === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedUserPostcode || ""}
                        onChange={e =>
                          this.setState({
                            editedUserPostcode: e.target.value
                          })
                        }
                      />
                      <label>Postcode</label>
                    </span>
                  </div>
                  <div className="ui-g-6">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedUserTown === "" ||
                          this.state.editedUserTown === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedUserTown || ""}
                        onChange={e =>
                          this.setState({
                            editedUserTown: e.target.value
                          })
                        }
                      />
                      <label>Town</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Save"
                    onClick={() => {
                      this.state.userAdded === true
                        ? this.addUser()
                        : this.editUser();
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Cancel"
                    onClick={() => {
                      this.state.userAdded === true
                        ? this.setState({
                            userSelected: false,
                            userEdited: false,
                            userAdded: false
                          })
                        : this.setState({
                            userSelected: true,
                            userEdited: false,
                            userAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Users Table*/}
            <div className="ui-g-12 card">
              <DataTable
                value={this.state.userList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      userSelected: true,
                      userEdited: false,
                      userAdded: false,
                      selectedUser: e.data,
                      userAddressLine1: e.data.addressLine1,
                      userAddressLine2: e.data.addressLine2,
                      userCodeTag: e.data.codeTag,
                      userContactTelephone: e.data.contactTelephone,
                      userCountryCode: e.data.countryCode,
                      userEmail: e.data.email,
                      userFirstName: e.data.firstName,
                      userId: e.data.id,
                      userLastUpdatedDateTime: e.data.lastUpdatedDateTime,
                      userPostcode: e.data.postcode,
                      userRoleType: e.data.roleType,
                      userSurname: e.data.surname,
                      userTown: e.data.town
                    },
                    () => {
                      console.log(this.state.selectedUser);
                    }
                  );
                }}
                header="Users"
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
                rows={10}
                emptyMessage="No Users"
              >
                <Column
                  field="firstName"
                  header="First Name"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="surname"
                  header="Surname"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="email"
                  header="Email"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine1"
                  header="Address Line 1"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine2"
                  header="Address Line 2"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </DataTable>
            </div>
            <div className="ui-g-12">
              <Button
                label="Create New"
                onClick={() => {
                  this.setState({
                    userSelected: false,
                    userEdited: true,
                    userAdded: true,
                    editedUserFirstName: "",
                    editedUserSurname: "",
                    editedUserEmail: "",
                    editedUserContactTelephone: "",
                    editedUserAddressLine1: "",
                    editedUserAddressLine2: "",
                    editedUserPostcode: "",
                    editedUserTown: ""
                  });
                }}
                style={{ float: "right" }}
              />
              <Button
                className="secondary-btn"
                label="Back"
                onClick={() => {
                  window.location = "#/contractors";
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Contractors/ContractorUsers.js